import { WallClockDateService } from '@mews-framework/datetime';
import { DateTimeLocalizationInfo } from '@mews-framework/globalization';

export const formatDynamicDate = ({
    value,
    currentDateTimeLocalizationInfo,
}: {
    value: string;
    currentDateTimeLocalizationInfo: DateTimeLocalizationInfo;
}) => {
    const isoDate = WallClockDateService.fromString(value, currentDateTimeLocalizationInfo);
    const normalizedDateFormat = currentDateTimeLocalizationInfo.dateFormat.replace(/dd|d/, 'dd').replace(/MM|M/, 'MM');

    return WallClockDateService.toString(isoDate, {
        ...currentDateTimeLocalizationInfo,
        cultureCode: `${currentDateTimeLocalizationInfo.cultureCode}-normalized`,
        dateFormat: normalizedDateFormat,
    });
};

export const formatDateValue = (
    dateValue: string,
    dateFormatPattern: string,
    currentDateTimeLocalizationInfo: DateTimeLocalizationInfo
) => {
    if (
        dateValue != null &&
        dateValue.length !== dateFormatPattern.length &&
        WallClockDateService.isValidString(dateValue, currentDateTimeLocalizationInfo)
    ) {
        return formatDynamicDate({ value: dateValue, currentDateTimeLocalizationInfo });
    }
    return dateValue;
};
